import { LaravelResponse, keyToUrl, withOptionsEndpoint } from "@dgs/core";
import axios from "axios";

import { TenantOptionResource } from "../types/tenant";

const baseKey = "user-tenants";
const allOptionsKey = [baseKey, "options", "all"];

export const userTenantService = {
	...withOptionsEndpoint<TenantOptionResource>([baseKey]),
	allOptions: () => axios.get<LaravelResponse<TenantOptionResource[]>>(keyToUrl(allOptionsKey)),
	allOptionsKey,
};
